<template>
  <a-modal
    title="人机验证"
    :closable="true"
    v-model="visible"
    @cancel="handleCancel"
    :maskClosable="true"
    :width="348"
    :footer="null"
  >
    <a-spin :spinning="Loading">
      <div ref="captcha" style="min-height:150px;"></div>
      <remote-js src="https://cdn.dingxiang-inc.com/ctu-group/captcha-ui/index.js"></remote-js>
    </a-spin>
  </a-modal>
</template>

<script>
export default {
  data() {
    return {
      Loading: false,
      visible: false
    }
  },
  created() {},
  methods: {
    handleCancel () {
        this.$emit('cancel')
    },
    start() {
      return new Promise((resolve, reject) => {
        this.Loading = true
        this.visible = true
        setTimeout(() => {
          this.Loading = false
          _dx.Captcha(this.$refs.captcha, {
            appId: '1c880deab4e4eced2c04786567ee7046',
            success: token => {
              resolve({ token })
              this.close()
            }
          })
        }, 1000)
      })
    },
    close() {
        this.visible = false
    }
  }
}
</script>
